/* Casa Renata — fix de storefront:
   1) shim de customElements.define: impede o erro "sticky-buy-button already defined"
      que quebra a init do seletor de variante (botão travava em "Esgotado" e swatches
      de cor não apareciam). Precisa rodar ANTES do pdp.js (por isso sem defer/module).
   2) reparo do swatch de cor (foto): força os thumbs visíveis + remove estado disabled. */
(function () {
  // ---- 1) shim (roda imediatamente, antes do pdp.js) ----
  try {
    var _def = window.customElements.define.bind(window.customElements);
    window.customElements.define = function (name, ctor, opts) {
      if (window.customElements.get(name)) return; // já definido -> ignora (evita throw)
      try { _def(name, ctor, opts); } catch (e) {}
    };
  } catch (e) {}

  // ---- 2) reparo dos swatches de cor (foto): bolinha redonda, sem moldura ----
  var _corSelected = false;
  function styleSwatches() {
    document.querySelectorAll('.f-thumb__list__item').forEach(function (li) {
      li.style.setProperty('display', 'inline-flex', 'important');
      li.style.setProperty('width', '48px', 'important');
      li.style.setProperty('height', '48px', 'important');
      li.style.margin = '5px 6px';
      li.style.setProperty('border-radius', '50%', 'important');
      li.style.setProperty('border', 'none', 'important');
      li.style.overflow = 'hidden';
      li.style.cursor = 'pointer';
      li.style.transition = 'box-shadow .15s ease';
      var img = li.querySelector('img');
      if (img) { img.style.setProperty('display', 'block', 'important'); img.style.width = '100%'; img.style.height = '100%'; img.style.objectFit = 'cover'; img.style.borderRadius = '50%'; }
      var lb = li.querySelector('label'); if (lb) { lb.style.display = 'block'; lb.style.width = '100%'; lb.style.height = '100%'; lb.style.borderRadius = '50%'; lb.style.overflow = 'hidden'; }
      var inp = li.querySelector('input'); if (inp) { inp.classList.remove('disabled'); inp.disabled = false;
        li.style.boxShadow = inp.checked ? '0 0 0 2px #FFFFFF, 0 0 0 4px #154734' : '0 0 0 1px rgba(0,0,0,.10)';
      }
    });
    var ul = document.querySelector('.f-thumb__list'); if (ul) { ul.style.display = 'flex'; ul.style.flexWrap = 'wrap'; ul.style.gap = '2px'; }
  }
  function repair() {
    styleSwatches();

    // botão add-to-cart: todo produto tem estoque real (900+), então força habilitado
    // quando há cor+tamanho selecionados (o cálculo de disponibilidade do tema falha aqui).
    var addBtn = document.querySelector('button[name="add"], .product-form__submit, [type="submit"][name="add"]');
    var corSel = document.querySelector('input[name="Cor"]:checked');
    var tamSel = document.querySelector('input[name="Tamanho"]:checked');
    if (addBtn && corSel && tamSel) {
      addBtn.removeAttribute('disabled'); addBtn.disabled = false; addBtn.classList.remove('disabled');
      var span = addBtn.querySelector('span') || addBtn;
      var addTxt = (window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho';
      if (/esgotado|indispon|sold/i.test(span.textContent)) span.textContent = addTxt;
    }

    // o tema só habilita tamanhos e resolve o botão se currentVariant existir,
    // e currentVariant só resolve com COR + TAMANHO selecionados. Selecionamos ambos.
    var cor = [].slice.call(document.querySelectorAll('input[name="Cor"]'));
    var tam = [].slice.call(document.querySelectorAll('input[name="Tamanho"]'));
    cor.concat(tam).forEach(function (i) { i.classList.remove('disabled'); i.classList.remove('unavailable'); i.disabled = false; });
    if (!_corSelected && cor.length && tam.length && !cor.some(function (i) { return i.checked; })) {
      _corSelected = true;
      cor[0].checked = true;
      cor[0].dispatchEvent(new Event('change', { bubbles: true }));
      styleSwatches();
      setTimeout(function () {
        tam[0].classList.remove('disabled'); tam[0].disabled = false;
        tam[0].checked = true;
        tam[0].dispatchEvent(new Event('change', { bubbles: true }));
      }, 120);
    }
  }
  // re-habilita tamanhos + botão APÓS o tema recalcular (a cada clique do usuário o tema
  // re-risca os tamanhos; aqui desfazemos, pois todo (cor×tamanho) tem estoque real).
  function keepEnabled() {
    document.querySelectorAll('input[name="Tamanho"], input[name="Cor"]').forEach(function (i) {
      i.classList.remove('disabled'); i.classList.remove('unavailable'); i.disabled = false;
    });
    var addBtn = document.querySelector('button[name="add"], .product-form__submit, [type="submit"][name="add"]');
    var corSel = document.querySelector('input[name="Cor"]:checked');
    var tamSel = document.querySelector('input[name="Tamanho"]:checked');
    if (addBtn && corSel && tamSel) {
      addBtn.removeAttribute('disabled'); addBtn.disabled = false; addBtn.classList.remove('disabled');
      var span = addBtn.querySelector('span') || addBtn;
      var addTxt = (window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho';
      if (/esgotado|indispon|sold/i.test(span.textContent)) span.textContent = addTxt;
    }
  }
  // MutationObserver no botão: o tema atualiza o add-to-cart de forma assíncrona e
  // volta pra "Esgotado". Sempre que ele fizer isso (com cor+tamanho válidos), revertemos.
  function watchButton() {
    var addBtn = document.querySelector('button[name="add"], .product-form__submit, [type="submit"][name="add"]');
    if (!addBtn || addBtn.__crWatched) return;
    addBtn.__crWatched = true;
    var addTxt = (window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho';
    var obs = new MutationObserver(function () {
      var corSel = document.querySelector('input[name="Cor"]:checked');
      var tamSel = document.querySelector('input[name="Tamanho"]:checked');
      if (!corSel || !tamSel) return;
      var span = addBtn.querySelector('span') || addBtn;
      var needs = addBtn.disabled || addBtn.hasAttribute('disabled') || /esgotado|indispon|sold/i.test(span.textContent);
      if (needs) {
        addBtn.disabled = false; addBtn.removeAttribute('disabled'); addBtn.classList.remove('disabled');
        if (/esgotado|indispon|sold/i.test(span.textContent)) span.textContent = addTxt;
      }
    });
    obs.observe(addBtn, { attributes: true, childList: true, subtree: true, characterData: true });
  }
  function boot() {
    repair(); watchButton();
    [300, 800, 1600, 2800, 4000].forEach(function (t) { setTimeout(function () { repair(); watchButton(); }, t); });
    document.addEventListener('change', function () { [40, 200, 500].forEach(function (t) { setTimeout(function () { keepEnabled(); styleSwatches(); }, t); }); }, true);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.f-thumb__list__item, input[name="Cor"], input[name="Tamanho"], label')) [80, 300].forEach(function (t) { setTimeout(function () { keepEnabled(); styleSwatches(); }, t); });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
